import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { ExpandableModule } from '@shared-ui-lib/expandable/expandable.module'
import { WagonHireHistoryRequestHeaderModule } from '@wagon-hire/wagon-hire-history/wagon-hire-history-request-header/wagon-hire-history-request-header.module'
import { LandingPageSectionContainerModule } from '@landing-page/components/container/landing-page-section-container.module'
import { TranslationModule } from '@localization-lib/language/translation.module'
import { MatIconModule } from '@angular/material/icon'

@Component({
    standalone: true,
    imports: [
        CommonModule,
        ExpandableModule,
        MatIconModule,
        WagonHireHistoryRequestHeaderModule,
        LandingPageSectionContainerModule,
        TranslationModule,
    ],
    selector: 'app-landing-page-faq',
    templateUrl: './landing-page-faq.component.html',
    styleUrls: ['./landing-page-faq.component.scss'],
})
export class LandingPageFAQComponent {
    faqs = [
        {
            question: 'LandingPageFaqQuestion1',
            answer: 'LandingPageFaqAnswer1',
        },
        {
            question: 'LandingPageFaqQuestion2',
            answer: 'LandingPageFaqAnswer2',
        },
        {
            question: 'LandingPageFaqQuestion3',
            answer: 'LandingPageFaqAnswer3',
        },
        {
            question: 'LandingPageFaqQuestion4',
            answer: 'LandingPageFaqAnswer4',
        },
        {
            question: 'LandingPageFaqQuestion5',
            answer: 'LandingPageFaqAnswer5',
        },
        {
            question: 'LandingPageFaqQuestion6',
            answer: 'LandingPageFaqAnswer6',
        },
        {
            question: 'LandingPageFaqQuestion7',
            answer: 'LandingPageFaqAnswer7',
        },
        {
            question: 'LandingPageFaqQuestion8',
            answer: 'LandingPageFaqAnswer8',
        },
    ]

    constructor() {}
}
